const subjects = [
  'Books',
  'Wine',
  'Coins',
  'Postage stamps',
  'Celebrity autographs',
  'Vinyl records',
  'Seashells',
  'Pictures',
  'Postcards',
  'Coffee',
  'Badges',
  'Alcohol',
  'Paintings'
];

export default subjects;